import { CCopyBlockFragments } from './c-copy-block'
import { CJotFormEmbedFragments } from './c-jot-form-embed'

export const CCustomComponentsLpFragments = {
  field: `
    fragment customComponentsLandingPage on customComponentsLandingPage_MatrixField {
      ... on customComponentsLandingPage_aboutVideo_Entry {
        typeHandle
      }
      ... on customComponentsLandingPage_backgroundImageCopy_Entry {
        typeHandle
      }
      ... on customComponentsLandingPage_comparisonTable_Entry {
        typeHandle
      }
      ... on customComponentsLandingPage_findADoctor_Entry {
        typeHandle
      }
      ... on customComponentsLandingPage_imageCopyBlocks_Entry {
        typeHandle
      }
      ... on customComponentsLandingPage_splitTestimonial_Entry {
        typeHandle
      }
      ... on customComponentsLandingPage_stats_Entry {
        typeHandle
      }
      ... on customComponentsLandingPage_testimonialsSlider_Entry {
        typeHandle
      }
      ...customComponentsLandingPage_copyBlock
      ...customComponentsLandingPage_jotFormEmbed
    }
    ${CCopyBlockFragments.customComponentsLandingPageBlock}
    ${CJotFormEmbedFragments.customComponentsLandingPageBlock}
  `,
}
